import { render, staticRenderFns } from "./SendToSignatureModal.vue?vue&type=template&id=48d8b818"
import script from "./SendToSignatureModal.vue?vue&type=script&lang=js"
export * from "./SendToSignatureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports